import InsureProcessPayment from './InsureProcessPayment';
export default InsureProcessPayment;
